module.exports = __webpack_public_path__ + "img/select-arrow-down.d34fda31.svg";